import { AccessToken } from '../../domain/AccessToken';

export const AccessTokenMap = {
  toDomain: (raw: { token: string }): AccessToken => ({
    value: raw.token,
  }),
};
